type FileExt =
  | `png`
  | `jpg`
  | `jpeg`
  | `gif`
  | `svg`
  | `webp`
  | `json`
  | `html`
  | `js`
  | `txt`
  | `ico`

function buildLocalPath(
  path: string,
  filename: string,
  filetype?: FileExt
): string {
  const pathArr: string[] = path.split(`/`).filter(slice => slice.length > 0)
  const cleanPath: string = pathArr.join(`/`)
  const cleanFilename: string = filename.replace(/\//, ``).split(`.`)[0]
  let validPath: string = `/${cleanPath}/${cleanFilename}`

  if (filetype) {
    const cleanFiletype: string = filetype.replace(/\\./, ``)
    validPath += `.${cleanFiletype}`
  }
  return validPath
}

export { buildLocalPath }
